import { useEffect, useState } from 'react';
import CustomForm from '../CustomForm/CustomForm';
import sleep from "sleep-promise";

function Form(props) {

    const [formContent, setFormContent] = useState(<></>);

    useEffect(() => {
        setFormContent(
            <></>
        );

        const load = async () => {

            let values = props.values;

            if (!values.permission_options) {
                values.permission_options = ["canView","canAdd","canEdit","canDelete","canInactivate"]
            }

            if (!values.type) {
                values.type = "1"
            }

            const form = {
                labelTitle: 'Editar',
                validateOnChange: true,
                showGoBackButton: false,
                containerType: 'dialog',
                fields: props.fields,
                values: values ? values : false,
                customValidators: props.customValidators,
                handleSubmit: (fields, values) => {
                    props.handleSubmit(fields, values, props.currentNode);
                }
            }

            await sleep(1)

            setFormContent(
                <CustomForm form={{ ...form }} />
            );
        };
        load();
    }, []);

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;